import React from "react";
import { CollectionNewSearchPageTranslations } from "../../CollectionNewSearchPageTranslations.csharp";
import { SearchParams } from "../../CollectionNewSearchPage";

export interface CollectionNewSearchBarProps {
    query: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSearch: (word?: string) => void;
    exampleSearchTerms: string[];
    translations: CollectionNewSearchPageTranslations;
    searchParams: SearchParams;
    setSearchParams: React.Dispatch<React.SetStateAction<SearchParams>>;
}

export const CollectionNewSearchBar: React.FC<CollectionNewSearchBarProps> = ({
    query,
    onChange,
    handleSearch,
    exampleSearchTerms,
    translations,
    setSearchParams,
    searchParams,
}) => {
    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSearch();
        }
    };

    const handleExampleClick = (word: string) => {
        onChange({ target: { value: word } } as React.ChangeEvent<HTMLInputElement>);
        handleSearch(word);
    };

    const handleClear = () => {
        onChange({ target: { value: "" } } as React.ChangeEvent<HTMLInputElement>);
        setSearchParams({
            ...searchParams,
            classification: "",
            themes: [],
            motifs: [],
        });
        handleSearch("");
    };

    return (
        <div className="SearchInput__wrapper">
            <label className="SearchInput__label" htmlFor="search">
                {translations.searchSearchButton}
            </label>
            <div className={`SearchInput__input ${query ? "SearchInput__input--has-query" : ""}`}>
                <input
                    type="text"
                    name="q"
                    id="search"
                    value={query}
                    onChange={onChange}
                    placeholder={translations.searchPlaceholder}
                    onKeyPress={handleKeyPress}
                />
                {query && (
                    <button
                        aria-label="Clear search"
                        onClick={handleClear}
                        className="SearchInput__clear-button"
                    ></button>
                )}
                <button
                    className="SearchInput__search-button"
                    onClick={() => {
                        handleSearch();
                    }}
                >
                    <span className="visuallyHidden">{translations.searchSearchButton}</span>
                </button>
            </div>

            {exampleSearchTerms && (
                <div className="SearchInput__example-words">
                    <span>{translations.searchExample} </span>
                    {exampleSearchTerms.map((word, index) => (
                        <span key={index}>
                            <span className="SearchInput__example-word" onClick={() => handleExampleClick(word)}>
                                {word}
                            </span>
                            {index < exampleSearchTerms.length - 1
                                ? index === exampleSearchTerms.length - 2
                                    ? `, ${translations.searchConjunction} `
                                    : ", "
                                : ""}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};
